<template>
  <div class="icon-picker">
    <div v-if="loading" class="loading-state">
      <span>Loading icons...</span>
    </div>
    <div v-else class="icon-grid">
      <div
        v-for="icon in availableIcons"
        :key="icon.id"
        class="icon-item"
        :class="{ selected: value === icon.fileurl_campaign_image }"
        @click="selectIcon(icon)"
      >
        <img :src="icon.fileurl_campaign_image" :alt="icon.id" class="icon-img" />
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/firestore";

export default {
  name: "IconPicker",
  props: {
    value: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      availableIcons: [],
      loading: true,
    };
  },
  mounted() {
    this.fetchIcons();
  },
  methods: {
    async fetchIcons() {
      try {
        this.loading = true;
        const db = firebase.firestore();
        const snapshot = await db.collection("universityCampaigns_icon").get();

        this.availableIcons = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        // Select first icon by default if no icon is currently selected
        if (!this.value && this.availableIcons.length > 0) {
          this.$emit("input", this.availableIcons[0].fileurl_campaign_image);
        }

        this.loading = false;
      } catch (error) {
        console.error("Error fetching campaign icons:", error);
        this.loading = false;
      }
    },
    selectIcon(icon) {
      this.$emit("input", icon.fileurl_campaign_image);
    },
  },
};
</script>

<style scoped>
.icon-picker {
  margin-bottom: 0;
}

.loading-state {
  padding: 20px;
  text-align: center;
  color: #6B7280;
  font-size: 14px;
}

.icon-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.icon-item {
  aspect-ratio: 1;
  border: 2px solid #E5E7EB;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  background: white;
  position: relative;
  padding: 8px;
}

.icon-item:hover {
  border-color: #7D5ABA;
  background: #F9FAFB;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(125, 90, 186, 0.15);
}

.icon-item.selected {
  border-color: #7D5ABA;
  background: linear-gradient(135deg, #F3EBFF 0%, #FAF5FF 100%);
  box-shadow: 0 0 0 3px rgba(125, 90, 186, 0.15);
  transform: scale(1.05);
}

.icon-item.selected::after {
  content: '✓';
  position: absolute;
  top: -6px;
  right: -6px;
  width: 24px;
  height: 24px;
  background: #7D5ABA;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  box-shadow: 0 2px 8px rgba(125, 90, 186, 0.3);
}

.icon-img {
  width: 72px;
  height: 72px;
  object-fit: contain;
  filter: grayscale(0.2);
  transition: filter 0.2s;
}

.icon-item.selected .icon-img {
  filter: grayscale(0);
}
</style>
